var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.slotComponent,{tag:"component"},[_vm._t("default",null,{"action":{ startUpload: _vm.startUpload }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }